module.exports = __webpack_public_path__ + "img/user-card-icon.be6f2126.svg";